<template>
  <v-layout v-if="!isMobile" justify-end align-center>
    <full-screen-spinner v-if="showSpinner" spinner-text="Logging out..." top-margin="0px" />
    <v-flex shrink>
      <div>
        <v-btn flat icon color="grey" @click="openCommunicationTab">
          <span
            v-if="clientUnreadMessages && clientUnreadMessages.length"
            class="header-client__unread-messages-count"
          >{{ clientUnreadMessages.length }}</span>
          <v-icon :color="colors.pending">
            email
          </v-icon>
        </v-btn>
      </div>
    </v-flex>
    <v-flex v-ripple shrink>
      <menu-account
        :user="clientData"
        :items="menuItems"
        @sign-out="signOut"
        @open-account="$router.push({ name: 'client-account' })"
      />
    </v-flex>
    <v-flex v-if="getWindowWidth < 1264" shrink class="pa-0">
      <v-toolbar-side-icon
        class="navigation-toggle"
        @click.stop="toggleDrawer"
      />
    </v-flex>
  </v-layout>
  <!-- Mobile layout -->
  <v-layout v-else class="toolbar-mobile" align-center justify-center>
    <v-flex v-if="showMobileBackButton" shrink @click="handlerMobileBackButton">
      <v-icon class="white--text back-button">
        chevron_left
      </v-icon>
    </v-flex>
    <v-flex x12 md7 lg5 class="text-center">
      <label v-if="isSavedFavorites" class="toolbar__title">SAVED FAVORITES</label>
      <label v-else-if="isViewDetails" class="toolbar__title">VIEW DETAILS</label>
      <label v-else class="toolbar__title">{{ getCurrentPageName }}</label>
    </v-flex>
    <v-flex shrink class="text-xs-right">
      <v-toolbar-side-icon class="navigation-toggle hwayzHeaderClient" @click.stop="toggleDrawer" />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import MenuAccount from '../common/navigation/MenuAccount.vue'
import FullScreenSpinner from '../uiUtils/FullScreenSpinner.vue'
import colors from '../../scss/_colors.scss'

export default {
  components: { MenuAccount, FullScreenSpinner },

  data() {
    return {
      colors,
      showSpinner: false,
      menuItems: [
        // {
        //   text: 'Account',
        //   icon: 'account_circle',
        //   callback: 'open-account'
        // },
        {
          text: 'Log Out',
          icon: 'exit_to_app',
          callback: 'sign-out'
        }
      ]
    }
  },

  computed: {
    ...mapState('common', [
      'isMobile',
      'drawer',
      'showMobileFeedbackModal',
      'showSingleRoutePropertyView'
    ]),
    ...mapState('communication', ['selectedThread', 'showNewThreadForm']),
    ...mapState('home', ['activeRoute']),
    ...mapState('client', ['clientData']),
    ...mapState('mobile', ['showMobileBackButton']),
    ...mapGetters('client', ['clientUnreadMessages']),

    getWindowWidth() {
      return this.$store.state.home.windowWidth
    },

    getCurrentPageName() {
      if (this.$store.state.home.activeRoute) {
        return this.$store.state.home.activeRoute.meta.title.toUpperCase()
      }
      return ''
    },

    isViewDetails() {
      const currentPath = this.$route.path
      const splitted = currentPath.split('/')

      if (splitted.length >= 4 && splitted[3] && splitted[2] === 'search') {
        return true
      } else {
        return false
      }
    },

    isSavedFavorites() {
      const currentPath = this.$route.path
      const splitted = currentPath.split('/')

      if (splitted.length >= 4 && splitted[3] && splitted[2] === 'favorites') {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    ...mapMutations('common', {
      setDrawerState: 'SET_DRAWER_STATE',
      setShowMobileFeedbackModal: 'SET_SHOW_MOBILE_FEEDBACK_MODAL',
      setShowSingleRoutePropertyView: 'SET_SHOW_SINGLE_ROUTE_PROPERTY_VIEW',
      resetMultipleRequestedObject: 'RESET_MULTIPLE_REQUESTED_OBJECT',
      resetSearchTextParams: 'RESET_SEARCH_TEXT_PARAMS',
      clearLastNewQuery: 'CLEAR_LAST_NEW_QUERY',
      setAddressInputValue: 'SET_ADDRESS_INPUT_VALUE',
      setDoScroll: 'SET_DO_SCROLL'
    }),
    ...mapMutations('mobile', {
      setAllRoutesShowing: 'SET_ALL_ROUTES_SHOWING',
      setShowingMobileBackButton: 'SET_SHOWING_MOBILE_BACK_BUTTON'
    }),
    ...mapMutations('client', {
      setDialogUser: 'SET_DIALOG_USER',
      setAssignToClient: 'SET_ASSIGN_TO_CLIENT'
    }),
    ...mapMutations('communication', {
      setThread: 'SET_THREAD',
      setShowNewThreadForm: 'SET_SHOW_NEW_THREAD_FORM'
    }),
    ...mapActions('common', ['profileLogout']),

    openCommunicationTab() {
      this.$router.push({ name: 'client-communication' })
    },

    toggleDrawer() {
      this.setDrawerState(!this.drawer)
    },

    handlerMobileBackButton() {
      if (this.showMobileBackButton) {
        if (this.activeRoute.name === 'client-communication') {
          if (this.showSingleRoutePropertyView) {
            this.setShowSingleRoutePropertyView(false)
            return
          }
          if (this.showMobileFeedbackModal) {
            this.setShowMobileFeedbackModal(false)
            return
          }
          if (this.showNewThreadForm) {
            this.setShowNewThreadForm(false)
            return this.setShowingMobileBackButton(false)
          }
          if (this.selectedThread) {
            this.setShowingMobileBackButton(false)
            return this.setThread(null)
          }
        }
        if (this.activeRoute.name === 'client-schedule') {
          return this.resolveMobileCalendarHandler()
        }
        if (this.activeRoute.name === 'client-favorites') {
          this.resolveClientFavoritesCalendarHandler()
          this.setDoScroll(true)
          return this.$router.push({ name: 'client-favorites' })
        }
        if (this.activeRoute.name === 'client-feedback') {
          if (this.showMobileFeedbackModal) {
            this.setShowingMobileBackButton(false)
            this.setShowMobileFeedbackModal(false)
            return
          }
        }
      }

      if (this.activeRoute.name === 'client-search-results') {
        this.resetSearchTextParams()
        this.resetMultipleRequestedObject()
        this.clearLastNewQuery()
        this.setAssignToClient({})
        this.setAddressInputValue({ text: '', suggestion: false })
      }
      return this.goBack()
    },

    goBack() {
      this.$router.go(-1)
    },

    resolveClientFavoritesCalendarHandler() {
      this.setShowingMobileBackButton(false)
      this.setShowMobileFeedbackModal(false)
    },

    resolveMobileCalendarHandler() {
      if (this.showSingleRoutePropertyView) {
        return this.setShowSingleRoutePropertyView(false)
      }
      if (this.showMobileFeedbackModal) {
        this.setShowingMobileBackButton(true)
        return this.setShowMobileFeedbackModal(false)
      }
      this.setShowingMobileBackButton(false)
      return this.setAllRoutesShowing(true)
    },

    signOut() {
      this.showSpinner = true
      setTimeout(() => {
        this.showSpinner = false
        this.profileLogout()
      }, 1500)
    }
  }
}
</script>

<style lang="sass">
.navigation-toggle
  @media only screen and (max-width: 760px)
    margin-right: 0 !important
  .v-btn__content i
    color: $hwayzDarkGray
    border-radius: 50%
    padding: 0.5rem
  button:hover
    @extend %on-hover

.back-button
  font-size: 3.5rem
</style>
